import React, { Component } from "react";
import LoadingPanel from "module-common/LoadingPanel";
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import InputRow from "module-common/InputRow"
import styled, { css } from "styled-components";
import MemberList from './MemberListWithQuery'


export default class AudienceDisplay extends Component {

    state = {
        companyName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        fromName: '',
        fromEmail: ''
    }

    contactInfoList = [
        {
            label: 'Company Name',
            stateName: 'companyName',
            type: 'text'
        },
        {
            label: 'Address 1',
            stateName: 'address1',
            type: 'textarea'
        },
        {
            label: 'Address 2',
            stateName: 'address2',
            type: 'textarea'
        },
        {
            label: 'City',
            stateName: 'city',
            type: 'text'
        },
        {
            label: 'State',
            stateName: 'state',
            type: 'text'
        },
        {
            label: 'Zip Code',
            stateName: 'zip',
            type: 'text'
        }
    ]

    campaignDefaultList = [
        {
            label: 'From Name',
            stateName: 'fromName',
            text: 'text'
        },
        {
            label: 'From Email',
            stateName: 'fromEmail',
            text: 'text'
        }
    ]
    componentDidMount() {
        const { audience: { contactInformation, campaignDefaults } = {}} = this.props
        if(contactInformation && campaignDefaults) {
            this.setState(state => ({
                ...state,
                companyName: contactInformation.companyName,
                address1: contactInformation.address1,
                address2: contactInformation.address2,
                city: contactInformation.city,
                state: contactInformation.state,
                zip: contactInformation.zip,
                country: contactInformation.country,
                phone: contactInformation.phone,
                fromName: campaignDefaults.fromName,
                fromEmail: campaignDefaults.fromEmail
            }))
        }
    }
    componentWillReceiveProps(nextProps) {
        const { audience: { contactInformation, campaignDefaults } = {}} = nextProps
        if(contactInformation && campaignDefaults) {
            this.setState(state => ({
                ...state,
                companyName: contactInformation.companyName,
                address1: contactInformation.address1,
                address2: contactInformation.address2,
                city: contactInformation.city,
                state: contactInformation.state,
                zip: contactInformation.zip,
                country: contactInformation.country,
                phone: contactInformation.phone,
                fromName: campaignDefaults.fromName,
                fromEmail: campaignDefaults.fromEmail
            }))
        }
    }

    renderSection = (title, inputList) => {
        return (
            <React.Fragment>
                <Title>{title}</Title>
                <InformationPanel>
                {inputList.map(({ label, stateName, type, width}) => (
                    <InputRow 
                        key={label}
                        type={type}
                        label={label}
                        inputWidth={width || 150}
                        value={this.state[stateName]}
                        onChange={text => {
                            this.setState(state => ({...state, [stateName]: text }))
                        }}
                    />))
                }
                </InformationPanel>
            </React.Fragment>
        )
    }

    render() {
        const { audience: { contactInformation, campaignDefaults, id } } = this.props
        
        return (
        <WrapperPost>
            <Wrap>
                <LeftColumn>
                  <Header>
                    <BigTitle>
                      Basic Information
                    </BigTitle>
                  </Header>
                  {this.renderSection('Contact Info', this.contactInfoList)}
                  {this.renderSection('Campaign Defaults', this.campaignDefaultList)}
                </LeftColumn>
                <RightColumn>
                  <Header>
                    <BigTitle>
                        Member
                    </BigTitle>
                  </Header>
                  <MemberList audienceId={id} />
                </RightColumn>
            </Wrap>
        </WrapperPost>)
    }
}

const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;

const Overlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: gray;
  opacity: 0.2;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  margin: 5px 20px 10px;
  height: 100%;
  position: relative;
`;

const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;

const Header = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d2d3d5;
  width: 100%;
`;

const BigTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #087cbc;
`;

const InformationPanel = styled.div`
  padding-left: 10px;
  margin-bottom: 10px;
`

const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;

const Wrap = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  /* border-top: 1px solid ${props => props.theme.panelBorder}; */
  height: 100%;
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 30%;
  align-items: flex-start;
  justify-content: left;
  padding: 3px 20px 3px 5px;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  padding: 3px 20px 3px 20px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
  padding-left: 5px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/AudienceDisplay.js